<template>
  <div class="webcardloginMain_012">
    <!-- <div class="accountMoney" v-if="integralList.length || cardDatalist.length"> -->
      <!-- <div class="accountMoney"  v-if="integralList.length && sign == dawei || integralList.length && sign == wtao || integralList.length && sign == snan || integralList.length && sign == wheng || integralList.length && sign == scao || integralList.length && sign == tfang || integralList.length && sign == lxshui || integralList.length && sign == qhjiao || integralList.length && sign == lmeng || integralList.length && sign == dcun || integralList.length && sign == sales1 || integralList.length && sign == sales2 ">  -->
      <div @click="ToIntegral" v-if="integralStatus== '0' && channel =='BAIHUO' && merchantId == ''">
        <span>点击这里可以给积分账户充值~</span>
        <span></span>
      </div>
    <!-- </div> -->
    <p class="userId">ID:{{userId}}</p>
    <div class="list_card_login_mine_012">
      <!-- 积分列表 -->
      <!-- <ul v-if="integralList.length > 0 && integralStatus== '0'">
        <li v-for="item in integralList" :key="item.id" @click="integralCardLogin(item.cardticketremaincount)">
          <div class="list_card_left"><img src="@/assets/img/images/imgT.jpg" /></div>
          <div class="list_card_right">
            <h3 v-show="item.cardticketremaincount">余额:{{item.cardticketremaincount ? item.cardticketremaincount : ''}}</h3>
            <h3>{{item.cardname}}</h3>
            <p>点击使用</p>
          </div>
        </li>
      </ul> -->
      <!-- 卡包列表 -->
      <ul v-if="cardDatalist.length">
        <li v-for="(item, index) in cardDatalist" :key="item.id" @click="cardDataCardLogin(index)" :style="{backgroundImage: `url(${cardLoginBack})`}">
          <div class="list_card_left" v-if="cityLogo != ''"><img :src="cityLogo"></div>
          <div class="list_card_left" v-else><img src="@/assets/img/images/imgT.jpg" /></div>
          <div class="list_card_right">
            <h3 v-show="item.cardticketremaincount">余额:{{item.cardticketremaincount ? item.cardticketremaincount : ''}}</h3>
            <h3>{{item.cardname}}</h3>
            <p>点击使用</p>
          </div>
        </li>
      </ul>
      <div class="center_box_list" v-if="cardDatalist.length == 0 && integralList.length == 0">
        {{errorMsg}}
      </div>
      <div class="webbottomheight"></div>
    </div>
    <div class="webbottom"  v-if="channel !='JIFENDH'">
      <div class="item1" @click="cardBind" :style="{background: `${colourName}`}">
        <p>绑定新卡</p>
      </div>
      <div v-if="myorder_url != '' && !isWXMINI " class="item1" @click="myOrder" style="background:#666">
        <p>{{myorder_name}}</p>
      </div>
    </div>
    <Bounced type='confirm' @took='queRenOk' @tocancel='() => showDio = false' :showstate='showDio'>
      <span slot='tlt'>提示</span>
      <div slot='text'>您的积分不足，是否前往充值 ?</div>
    </Bounced>
  </div>
</template>
<script>
import * as api from "@/api";
import JmmToast from '@/components/JmmToast'
import Bounced from "@/components/Bounced";
import wx from "weixin-js-sdk";
export default {
  name: "userWrap",
  data() {
    return {
      colourName: '',
      cardLoginBack: require("../../assets/img/images/bgCard.png"),
      token: "jjcimpilpgejfeehkdinjlbgabbgchhe",
      showDio: false, // 模态框
      sign: "", // 签名
      integralList: [], // 积分卡数组
      cardDatalist: [], // 非积分卡数组
      mobile: "", // 手机号 判断有没有
      userId: '', // 用户的id
      openId: '', // 用户的openid

      // 小程序测试-白名单
      dawei: 'cfbklfkgmjfpcnllgfmjdeicjmifkjhhhpagghfkkafelpamjmiigdhkknhfgegn',
      wtao: 'jmindmipdhiiclloneblpapjnchofjegjinpaekaoepkalibglfopkeopfgeajfi',
      snan: 'bhihhpopfeiiphfgmjjejgemogkceadkamkpkmjgkgbdeegfmefcjiiaghkjghil',
      wheng: 'oiecafblacikokkpkoeemplkcceepolpcbgegfhchipooafhdahoelggdbbgggjg',
      scao: 'fhkhgfljjhndihpcbkkbblgbjigheoolflnlokcodccilkiodncldifchelmlmml',
      tfang: 'bliflggikdmombpnlpigladcokhnjpdgfacjgopbelfmhdmdceodgdfkgfhnpogp',
      lxshui: 'lohedgnfkhabfoobeihhkcgmgcnnlfeipkidondfnongbbffpfmhemhhohajdefd',
      qhjiao: 'geplefmlgkbjodcjmkgggklmigdnmopnkmalclcbocgokkdoiidbnbejbajgmnbm',
      lmeng: 'hkalkcamdkhpmcjfjgaipacjoaohjgaccbgegfhchipooafhdahoelggdbbgggjg',
      dcun: 'ndbnijcfnclnfppppjpnnjedbppceblhjinpaekaoepkalibglfopkeopfgeajfi',
      sales1: 'dcllnogadmgfoickmplmckcemnbdbnaeflnlokcodccilkiodncldifchelmlmml',
      sales2: 'jhjfogmadeonimkgmjlpbflepklpkbkmdlndoonfgbdcplakckplnbojmoekaebj',

      return_url: '', // 绑定成功后跳转 地址
      return_url_jump: '', // 绑定成功后跳转 地址
      myorder_url: '',// 我的订单跳转地址
      myorder_name: '',// 我的菜单名字
      cardrights: '', // 权限 要取业务传递来的参数,不能写死参数
      appid: "",      // 用户中心公众号
      cityLogo: "",   // 城市logo
      displayType: "",   // 账户显示色调
      channel: '',    // 识别是不是百货的业务
      // code: '',    // 获取到的code

      sessionKeyReq: '',
      signReq: '',
      userFlag: '',   //是否存在数字人民币
      errorMsg: '没找到卡，请您点击下方绑卡哦~ ',         //错误信息
      merchantId: '',
      stateId: '',


      isWXMINI: false, //是否是在微信小程序webview环境中
    };
  },
  created() {
    this.merchantId = this.$route.query.merchantId;
    this.stateId = this.$route.query.state;
    if(null != this.merchantId && undefined != this.merchantId && "merchantId" != this.merchantId){
      localStorage.setItem('cityMerchantId', this.merchantId);
    } else if(null != this.stateId && undefined != this.stateId && "merchantId" != this.stateId){
      this.merchantId = this.stateId;
      localStorage.setItem('cityMerchantId', this.merchantId);
    } else {
      localStorage.setItem('cityMerchantId', "");
    }
    if(null == this.merchantId){
      this.merchantId = '';
    }
    if(undefined == this.merchantId){
      this.merchantId = '';
    }
    this.return_url = this.$route.query.return_url;
    this.myorder_url = this.$route.query.myorder_url;
    this.myorder_name = this.$route.query.myorder_name;
    this.cardrights = this.$route.query.cardrights;
    this.isRecharge = this.$route.query.isRecharge;
    this.channel = this.$route.query.channel;
    this.filterType = this.$route.query.filterType;
    this.integralStatus = this.$route.query.integralStatus;

    //判断渠道ID
    if (null == this.channel || undefined == this.channel) {
      this.channel = '';
    }
    //过滤条件
    if (null == this.filterType || undefined == this.filterType) {
      this.filterType = '';
    }
    //积分显示状态
    if (null == this.integralStatus || undefined == this.integralStatus) {
      this.integralStatus = '0';
    }
    //我的订单
    if(null == this.myorder_url || undefined == this.myorder_url){
      this.myorder_url = '';
    }
    //我的菜单名称
    if(null == this.myorder_name || undefined == this.myorder_name || '' == this.myorder_name){
      this.myorder_name = '我的订单';
    }
    // this.sign = this.$route.query.sign;
    // this.mobile = this.$route.query.mobile;
    localStorage.setItem('homelist', window.location.href.split("cardrights=")[1])
    // this.getCode()

    this.sessionKeyReq = this.$route.query.sessionKey;
    if (null == this.sessionKeyReq || undefined == this.sessionKeyReq) {
      this.sessionKeyReq = '';
    }
    this.signReq = this.$route.query.sign;
    if (null == this.signReq || undefined == this.signReq) {
      this.signReq = '';
    }
  },
  mounted() {
    if ('' != this.sessionKeyReq && '' != this.signReq) {
      localStorage.setItem('reSESSIONKEY', this.sessionKeyReq)
      localStorage.setItem('codeSign', this.signReq)
      this.getList(this.signReq)
    } else {
      this.getwebAppId()
    }

    wx.miniProgram.getEnv((res) => {
      if (res.miniprogram) {
        this.isWXMINI = true;
      }
    })



  },
  components: { 
    JmmToast, Bounced
  },
  computed: {
      styleVar() {
        return {
          '--colourName': this.colourName,
          '--cardLoginBack': this.cardLoginBack
        }
      }
    },
  methods: {
    myOrder() {
      const that = this
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        //微信环境 JmmToast("微信环境"+1.5)
        wx.miniProgram.getEnv(function (res) {
          //JmmToast("微信环境"+2)
          if (res.miniprogram) {
            wx.miniProgram.navigateBack({
              delta: 1
            })
            wx.miniProgram.postMessage({
              data: {
                order_url: that.myorder_url,
                sessionKey: localStorage.getItem('reSESSIONKEY'),
                action: 'order'
              }
            })
            return
          }
        })
        
      }

      let toUrl = `${this.myorder_url}&sessionkey=${localStorage.getItem('reSESSIONKEY')}`
      window.location.href = toUrl;
    },
    // 5.2 调取 跳转积分卡页面的方法
    queRenOk() {
      this.ToIntegral()
    },
    // 4.1 跳转积分页面
    async ToIntegral() {
      const res = await api.user.getIntegralsign()
      if (res.code == '000000') {
        let dataJson = {
          goodsType: 50000,
          backUrl: `${window.location.href}&isRecharge=1`,
          number: 1,
          notifyUrl: `https://accountapi.kangou.cn/api/code/huidiaoPost`,
          // notifyUrl: 'https://test2.gonghuidefu.com/api/code/huidiaoPost', // https://accountapi.kangou.cn/api/code/huidiaoPost
          source: 3,
          isRecharge: 1,
          openId: this.openId
        }
        let inteUrl = `https://pay.kangou.cn/paycenter/api/card/toRechargePage/?businessId=${res.data.businessId}&userId=${this.userId}&time=${res.data.time}&sign=${res.data.sign}&channel=${this.channel}&data=${encodeURIComponent(JSON.stringify(dataJson))}`
        window.location.href = inteUrl
        this.showDio = false
      }
    },
    // 获取城市appId
    async getwebAppId(){
      try {
        let info = {}
        const res = await api.user.getwebAppId(info)
        if (res.code == "000000") {
          this.appid = res.data.appId;
          this.cityLogo = res.data.logo;
          this.displayType = res.data.displayType;
          if(this.cityLogo == null || this.cityLogo == undefined){
            this.cityLogo = "";
          }
          if(this.displayType === '0'){
            this.colourName = "#f8992d";
            this.cardLoginBack = require("../../assets/img/images/new/bgCard.png");
          } else{
            this.colourName = "#ff1734";
          }
          localStorage.setItem('cityLogo', this.cityLogo);
          localStorage.setItem('displayType', this.displayType);
          this.getCode();
        } else {
          this.getCode();
        }
      } catch (err) {
        this.getCode();
        console.log(err)
      }      
    },
    //  1 code地址
    getUrlCode() { // 截取url中的code方法
      var url = location.search
      var theRequest = new Object()
      if (url.indexOf("?") != -1) {
        var str = url.substr(1)
        var strs = str.split("&")
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = (strs[i].split("=")[1])
        }
      }
      return theRequest
    },
    // 2 非静默授权，第一次有弹框
    getCode() {
      this.code = ''
      var local = window.location.href // 获取页面url
      if(local.indexOf("?code=") != -1 && local.indexOf("#/?") != -1){
        // 获取授权后的code位置
        var codeBeg = local.indexOf("?code=");
        var codeEnd = local.indexOf("#/?");
        // 截取授权后的code数据
        var codeCut = local.substring(codeBeg, codeEnd);
        local = local.replace(codeCut, "");
      }
      this.code = this.getUrlCode().code // 截取code
      if (!this.code) { // 如果没有code，则去请求
        // if (this.code == null || this.code == '' || this.code == undefined) { // 如果没有code，则去请求
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_userinfo&state=${this.merchantId}&connect_redirect=1#wechat_redirect`
      } else {
        var merchantIdState = this.getUrlCode().state // 截取state
        if(null == merchantIdState || undefined == merchantIdState){
          merchantIdState = '';
        }
        if('' == this.merchantId && '' != merchantIdState){
          this.merchantId = merchantIdState;
          localStorage.setItem('cityMerchantId', this.merchantId);
        }
        // 通过code获取信息 
        this.fetch(this.code)
      }
    },
    //  code 登录
    async fetch(codeNum) {
      try { 
        let info = { "appId": this.appid, "wxcode": codeNum }
        localStorage.setItem('reToken', this.token)
        const res = await api.user.getwebLogin(info)
        if (res.code == "000000") {
          this.sign = res.data.sign;
          this.mobile = res.data.mobile;
          this.userId = res.data.userid;
          this.openId = res.data.openid;
          this.userFlag = res.data.userFlag;
          localStorage.setItem('reSESSIONKEY', res.data.SESSIONKEY)
          localStorage.setItem('codeSign', res.data.sign)
          this.getList(res.data.sign)
        } else {
          if (res.code == '40163' || res.code == '40029') {
            var local = window.location.href // 获取页面url
            if(local.indexOf("?code=") != -1 && local.indexOf("#/?") != -1){
              // 获取授权后的code位置
              var codeBeg = local.indexOf("?code=");
              var codeEnd = local.indexOf("#/?");
              // 截取授权后的code数据
              var codeCut = local.substring(codeBeg, codeEnd);
              local = local.replace(codeCut, "");
            }
            // 重新访问 此路径地址
            window.location.href = local;
            // window.location.href = this.channel == '' ? `h5cardloginlist.html#/?cardrights=${localStorage.getItem('homelist')}` :
            //   `h5cardloginlist.html#/?channel=${this.channel}&cardrights=${localStorage.getItem('homelist')}`
            // this.$forceUpdate()
          }
        }
      } catch (err) {
        console.log(err)
      }
    },
    // 3 获取列表
    async getList(sign) {
      try {
        localStorage.setItem("reToken", this.token);
        // let params = {
        //   "sign": sign,
        //   "channel": this.channel,
        //   "cardType": "17",
        //   "cardRights": "4001",
        //   "filterType": this.filterType,
        //   "integralStatus": this.integralStatus,
        //   "getIntegral": this.isRecharge == 1 ? "1" : ''
        // }
        // if ("50000" != this.cardrights) {
        //   const integralResult = await api.user.getIntgerCard(params);
        //   //积分列表
        //   this.integralList = integralResult.data;
        // }
        if (null == this.integralList) {
          this.integralList = [];
        }
        let info = {
          "userid": 0,
          "sign": sign,
          "channel": this.channel,
          "cardRights": this.cardrights,
          "filterType": this.filterType,
          "integralStatus": this.integralStatus,
          "getIntegral": this.isRecharge == 1 ? "1" : '',
          "userFlag": this.userFlag
        }
        const cardDataResult = await api.user.getcardWebLoginList(info);

        let errorMsg = cardDataResult.errorMsg;
        if(null != errorMsg && undefined != errorMsg && '' != errorMsg){
          this.errorMsg = errorMsg;
        }

        
        //卡包列表
        this.cardDatalist = cardDataResult.data;
        let integralBool = true; //this.sign == this.dawei || this.sign == this.wtao || this.sign == this.snan || this.sign == this.wheng || this.sign == this.scao || this.sign == this.tfang || this.sign == this.lxshui || this.sign == this.qhjiao || this.sign == this.lmeng || this.sign == this.dcun || this.sign == this.sales1 || this.sign == this.sales2
        if (!integralBool) {
          this.integralList = [];
        }
      } catch (error) {
        JmmToast(error)
      }
    },
    // async integralCardLogin(money) {
    //   if (money) {
    //     if (Math.ceil(money) > 0) {
    //       localStorage.setItem("reToken", this.token);
    //       let info = {
    //         "index": 0,
    //         "sign": this.sign,
    //         "channel": this.channel,
    //         "cardType": "17",
    //         "cardRights": '4001',
    //         "filterType": this.filterType,
    //         "integralStatus": this.integralStatus,
    //       }
    //       const res = await api.user.getwebLoginUpdateKey(info);
    //       if (res.code == '000000') {
    //         let jumpUrl = res.data.card.jumpUrl;
    //         if (null != jumpUrl && undefined != jumpUrl && '' != jumpUrl) {
    //           this.return_url = jumpUrl;
    //         }
    //         //获取本地的sessionKey
    //         let localSessionKey = localStorage.getItem('reSESSIONKEY');
    //         if (this.return_url.indexOf("?") != -1) {
    //           let toUrl = `${this.return_url}&cardrights=${this.cardrights}&channel=${this.channel}&sessionkey=${localSessionKey}`
    //           let toUrl2 = `${this.return_url}&cardrights=${this.cardrights}&sessionkey=${localSessionKey}`
    //           window.location.href = this.channel == '' ? toUrl2 : toUrl
    //         } else {
    //           let toUrl = `${this.return_url}/?cardrights=${this.cardrights}&channel=${this.channel}&sessionkey=${localSessionKey}`
    //           let toUrl2 = `${this.return_url}/?cardrights=${this.cardrights}&sessionkey=${localSessionKey}`
    //           window.location.href = this.channel == '' ? toUrl2 : toUrl
    //         }
    //       } else {
    //         JmmToast(res.message);
    //       }
    //     } else {
    //       this.showDio = true
    //     }
    //   }
    // },

    async cardDataCardLogin(index) {
      try {
        localStorage.setItem("reToken", this.token);
        let info = {
          "index": index,
          "sign": this.sign,
          "channel": this.channel,
          "cardRights": this.cardrights,
          "filterType": this.filterType,
          "integralStatus": this.integralStatus,
          "userFlag": this.userFlag
        }
        const res = await api.user.getwebLoginUpdateKey(info);
        if (res.code == '000000') {
          let jumpUrl = res.data.card.jumpUrl;
          if (null != jumpUrl && undefined != jumpUrl && '' != jumpUrl) {
            if(this.return_url.indexOf("?") != -1){
              var begNum = this.return_url.indexOf("?") + 1;
              var returnParam = this.return_url.substring(begNum, this.return_url.length);
              if(jumpUrl.indexOf("?") != -1){
                this.return_url = jumpUrl + "&" + returnParam;
              } else{
                this.return_url = jumpUrl + "?" + returnParam;
              }
            } else{
              this.return_url = jumpUrl;
            } 
          }
          //获取本地的sessionKey
          let localSessionKey = localStorage.getItem('reSESSIONKEY');
          var ua = navigator.userAgent.toLowerCase()

          console.log('click ================================================');
          const that = this
          if (ua.match(/MicroMessenger/i) == 'micromessenger') {
            //微信环境 JmmToast("微信环境"+1.5)
            wx.miniProgram.getEnv(function (res) {
              console.log('11111111111111');
              //JmmToast("微信环境"+2)
              if (res.miniprogram) {
                
                console.log('222222222222222');
                
                
                
                wx.miniProgram.postMessage({
                  data: {
                    return_url: that.return_url,
                    sessionKey: localSessionKey,
                    action: 'login'
                  }
                })
                wx.miniProgram.navigateBack({
                  delta: 1
                })
                
                console.log('333333333333333');
                
                return
              }
            })
            
          }
          console.log('444444444444444');

          if (this.return_url.indexOf("?") != -1) {
            // 跳转到业务方
            let toUrl1 = `${this.return_url}&cardrights=${this.cardrights}&channel=${this.channel}&sessionkey=${localSessionKey}`
            let toUrl2 = `${this.return_url}&cardrights=${this.cardrights}&sessionkey=${localSessionKey}`
            window.location.href = this.channel == '' ? toUrl2 : toUrl1
          } else {
            // 跳转到业务方
            let toUrl1 = `${this.return_url}?cardrights=${this.cardrights}&channel=${this.channel}&sessionkey=${localSessionKey}`
            let toUrl2 = `${this.return_url}?cardrights=${this.cardrights}&sessionkey=${localSessionKey}`
            window.location.href = this.channel == '' ? toUrl2 : toUrl1
          }
          // this.$forceUpdate()
        } else {
          JmmToast(res.message);
        }
      } catch (error) {
        console.log(error)
      }
    },
    cardBind: function() {
      this.return_url_jump = decodeURIComponent(this.return_url);
      this.return_url_jump = encodeURIComponent(this.return_url)
      if (this.mobile) {
        let toUrl1 = `h5webcardbind.html#/?merchantId=${this.merchantId}&sign=${this.sign}&channel=${this.channel}&cardrights=${this.cardrights}&return_url=${this.return_url_jump}`
        let toUrl2 = `h5webcardbind.html#/?merchantId=${this.merchantId}&sign=${this.sign}&cardrights=${this.cardrights}&return_url=${this.return_url_jump}`
        window.location.href = this.channel == '' ? toUrl2 : toUrl1
      } else {
        let toUrl1 = `h5cardlogin.html#/?merchantId=${this.merchantId}&sign=${this.sign}&channel=${this.channel}&return_url=${this.return_url_jump}&cardrights=${this.cardrights}`
        let toUrl2 = `h5cardlogin.html#/?merchantId=${this.merchantId}&sign=${this.sign}&return_url=${this.return_url_jump}&cardrights=${this.cardrights}`
        window.location.href = this.channel == '' ? toUrl2 : toUrl1
      }
    },
  },
};

</script>
<style lang="stylus">
  @import '../../assets/css/common.styl';
  @import '../../assets/css/icon.css';
  @import '../../assets/css/stylesheet.css';
  .webcardloginMain_012 {
    width: 100%;
    height: 100%;
    overflow: auto;
    background: #f5f5f5;
  }
  .accountMoney {
    width: 99%;
    line-height: 50px;
    padding: 15px 0;
    border: 1px solid #ddd;
    margin:0 auto;
    margin-top: 12px;
    background-color #fff
    div {
      width: 93%;
      margin: 0 auto;
      display flex
      justify-content space-between
      align-items center
      font-size 28px
      span:first-child {
        display block
      }
      span:last-child {
        display block
        width: .25rem;
        height: .25rem;
        border-top: 0.04rem solid #000;
        border-right: 0.04rem solid #000;
        transform: rotate(45deg);
        -webkit-transform: rotate(45deg);
      }
    }
  }
  .webcardloginHead .headleft{
    float:left;
    text-align :left;
    width:70%;
    font-size :30px;
    height :50px;
  }
  .webcardloginHead .headright{
    float :right;
    text-align :right;
    width:30%;
    font-size :30px;
    height :50px;
  }
  .list_card_login_mine_012 ul {
     width: calc(100% - 40px);
     margin: 0 auto;
     color: #fff;
     li {
        width: 100%
        height 205px
        background: url('../../assets/img/images/bgCard.png') no-repeat center;
        background-size: cover;
        margin: 20px auto;
        border-radius: 15px;
        display flex
        align-items center
        .list_card_left,  .list_card_right {
           padding-left: 35px;
        }
       .list_card_right {
          h3 {
            font-size 33px
          }
          p {
            font-size 28px
          }
        }
        .list_card_left img {
          width: 100px;
          height: 100px;
        }
     }
  }
  .webbottom {
    position: fixed;
    bottom: 0px;
    background-color: #fff;
    width: 100%;
    height: 80px;
    text-align: center;
    display: flex;
    flex-direction: row;
  }
  .webbottom .item1 {
    width: 50%;
    float: left;
  }
  .webbottom .item1 p {
    margin: 0;
    font-size: 28px;
    color: #fff;
    line-height: 80px;
  }
  .webbottom .item2 {
    width: 50%;
    background: #999999;
    float: left;
  }
  .webbottom .item2 p {
    margin: 0;
    font-size: 28px;
    color: #fff;
    line-height: 80px;
  }
  .webbottomheight {
    height: 150px;
  }
  .center_box_list {
    font-size: 28px;
    font-family: Source Han Sans SC VF;
    text-align: center;
    border-radius: 20px;
    width: 80%;
    height: 350px;
    margin: auto;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/view/h5cardloginlist/index.vue